export default "__VITE_ASSET__qbT6eR5I__"